var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.banner.theme === 'glowy')?_c('compare-headline-canvas-glowy'):_c('compare-headline-canvas-blobless')],1)}
var staticRenderFns = []

export { render, staticRenderFns }